<template>
  <b-container>
    <div v-if="pairWithDist !== null" class="vdist">
      <b-row>
        <b-col cols="12" md="5">
          <h3> Para nr {{pairWithDist.pair.id}}</h3>
        </b-col>
        <b-col cols="12" md="7">
          <div class="imgsWrapper">
            <ShoeImgs :pair="pairWithDist.pair.shoes" class="h-50"/>
          </div>
        </b-col>
        <b-col cols="12">
          <distribution :values="pairWithDist.distribution"></distribution>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>

import {api} from '@/utils'
import ShoeImgs from "@/components/ShoeImgs";
import Distribution from "@/components/Distribution";

export default {
  name: 'PairPage',
  components: {Distribution, ShoeImgs},
  props: ["axios"],
  data: function () {
    return {
      pairWithDist: null,
    }
  },
  created() {
    this.loadPair()
  },
  methods: {
    loadPair() {
      this.axios.get(api(`pair/${this.$route.params.id}`))
          .then(resp => {
            this.pairWithDist = resp.data;
          })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.imgsWrapper {
  height: 50vh;
}
</style>
